import { operationLog } from "../services/home";

interface pagePointInter {
  pageId: string;
  menuId?: string;
  pageName: string;
  extInfo?: string;
  pagePath: string;
  uid?: string;
  typeId?: string;
  uidType?: string;
  gameName?: string;
}

export interface btnPointInter {
  buttonId: string;
  extInfo: string;
  pageId: string;
  typeId?: string;
  buttonName?: string; // （1.1.0 版本新增参数） 按钮英文名
  uidType?: string; // （1.1.0 版本新增参数） ID类型，枚举值：edition_id、unified_id、app_id、game_code、company_id、developer_id、publisher_id
  uid?: string; // （1.1.0 版本新增参数） 应uidType类型的ID值。如经分、datalab打点：uidType为”game_code”，uid填具体的gameCode，如”i_game”、“demo”等；情报打点：uidType: “edition_id”，uid: “u080032403b0f3dxxxxxxx”
  gameName?: string; // （1.1.0 版本新增参数）可以是游戏名，公司名，业务名；gameName 英文名
}
export interface pointInter {
  pageId: string;
  pageName: string;
  pagePath: string;
  typeId: string;
  extInfo?: string;
  gameName?: string;
  uidType?: string;
  uid?: string;
}
export interface pointInterId extends pointInter{
  uid: string;
  uidType: string;
}

interface searchInter {
  typeId: string;
  extInfo?: string;
}

export const typeIdObj = {
  home: 'homePage_pc_v2',
  intelligence: 'intelligence_pc_v2',
  studio: 'studio_pc',
  userCenter: 'user-center_pc_v2',
};

interface IPageLog {
  source?: number;
  typeId?: string;
  isOnline: string;
  menuId?: string;
  pageId: string;
  pageName: string;
  pagePath: string;
  uidType?: string;
  uid?: string;
  extInfo?: string;
  gameName?: string;
}

// 进入页面的埋点和自定义组件点击事件埋点,打点应该不影响页面功能，所以注意不要用await
export const buriedPoint = (paramsObj: pagePointInter) => {
  const { menuId = '', pageId = '', pageName = '', extInfo = '', pagePath = '', uid = '', typeId = 'dashboard_pc_v2', uidType = 'game_code', gameName = '' } = paramsObj;

  const pageLog: IPageLog = {
    source: 0,
    extInfo,
    typeId,
    isOnline: 'logIn',
    pageName,
    pagePath,
    uidType,
    uid,
    pageId,
    menuId,
    gameName,
  };

  const params = {
    logType: 'pageLog',
    openId: '',
    pageLog,
  };
  // 这样写可以防止日志报错，用try catch的话还是会报错
  operationLog(params).then(()=>{}).catch((e)=>{console.log(e)});
};

// 按钮打点
export const buriedBtnPoint = (paramsObj: btnPointInter) => {
  const { buttonId, extInfo, pageId, typeId = 'dashboard_pc_v2', buttonName, uidType, uid, gameName } = paramsObj;
  const params = {
    logType: 'buttonLog',
    openId: '',
    buttonLog: {
      source: 1,
      typeId,
      buttonId,
      extInfo,
      pageId,
      // 新增参数
      buttonName,
      uidType,
      uid,
      gameName,
    }
  };
  // 这样写可以防止日志报错，用try catch的话还是会报错
  operationLog(params).then(()=>{}).catch((e)=>{console.log(e)});
};


// 首页、情报页面埋点 ，配合PageLogMes配置
export const buriedPointPage = (paramsObj: pointInter) => {
  const { pageId = '', pageName = '', extInfo = '', pagePath = '', typeId } = paramsObj || {};
  const params = {
    logType: 'pageLog',
    openId: '',
    pageLog: {
      source: 0,
      extInfo,
      typeId,
      isOnline: 'logIn',
      pageId,
      pageName,
      pagePath,
    }
  };
  // 这样写可以防止日志报错，用try catch的话还是会报错
  operationLog(params).then(()=>{}).catch((e)=>{console.log(e)});
};
// 游戏埋点 ，配合PageLogMes配置
export const buriedPointGame = (paramsObj: pointInter, gameId: string, uidType = "edition_id") => {
  const { pageId = '', pageName = '', extInfo = '', pagePath = '', typeId, gameName = '' } = paramsObj;
  const params = {
    logType: 'pageLog',
    openId: '',
    pageLog: {
      source: 0,
      extInfo,
      typeId,
      isOnline: 'logIn',
      pageId,
      pageName,
      pagePath,
      uid: gameId,
      uidType,
      gameName,
    }
  };
  // 这样写可以防止日志报错，用try catch的话还是会报错
  operationLog(params).then(()=>{}).catch((e)=>{console.log(e)});
};

// 搜索打点
export const buriedPointSearch = (paramsObj: searchInter, query = '', gameId = '', clickId = '', uidType = '') => {
  const { extInfo = '', typeId } = paramsObj;
  const params = {
    logType: 'searchLog',
    openId: '',
    searchLog: {
      source: 1,
      extInfo,
      query,
      typeId,
      clickId,
      uid: gameId,
      uidType,
    }
  };
  // 这样写可以防止日志报错，用try catch的话还是会报错
  operationLog(params).then(()=>{}).catch((e)=>{console.log(e)});
};
